import { Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON, isValidStored } from '../../_helpers/storage.util';
import { environment } from '../../../environments/environment';
declare var $:any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnDestroy {

  @ViewChild('faqVideoCarousel', { static: false }) faqVideoCarousel?: ElementRef<HTMLElement>;

  public loginTrue:boolean= false;
  public FaqList:any =[];
  public loginDetail:any =[];
  public backFile:any='';
  public loading:boolean = true;
  public errorMessage: string = '';
  public showButton:boolean=true;
  public FaqOtherDetail:any=[];
  public Faqdata:any=[];
  public FaqVideoCarousel:any[] = [];
  // Keep six cards in the FAQ even while the API has no configured videos.
  // Editors can populate the cards later without changing the public layout.
  public FaqVideoCarouselSlots:any[] = Array.from({ length: 6 }, () => null);
  public FaqVideoCarouselRenderItems:any[] = Array.from({ length: 6 }, () => null);
  public carouselPage = 0;
  private carouselScrollSettleTimer: ReturnType<typeof setTimeout> | undefined;
  public currentTime = 0;
  public videoDuration = 0;
  public videoProgress = 0;
  public volume = 1;
  public isMuted = false;
  public playbackRate = 1;
  public showSettings = false;
  public annotationsEnabled = true;
  public sleepTimerMinutes = 0;
  private sleepTimerId: ReturnType<typeof setTimeout> | undefined;

  public isBunnyVideo(url: any): boolean {
    const value = String(url || '');
    return value.includes('iframe.mediadelivery.net') || value.includes('/embed/');
  }

  retryFaq() {
    this.getFaqs();
  }

  previousCarouselVideo(): void {
    const pageCount = this.carouselPages.length;
    if (pageCount < 2) return;
    this.goToCarouselPage((this.carouselPage - 1 + pageCount) % pageCount);
  }

  nextCarouselVideo(): void {
    const pageCount = this.carouselPages.length;
    if (pageCount < 2) return;
    this.goToCarouselPage((this.carouselPage + 1) % pageCount);
  }

  get carouselPages(): number[] {
    const cardCount = this.hasPlaceholderCarousel
      ? this.FaqVideoCarouselSlots.length
      : this.FaqVideoCarousel.length;
    return Array.from(
      { length: Math.ceil(cardCount / this.visibleCarouselCards) },
      (_, index) => index
    );
  }

  goToCarouselPage(page: number): void {
    const carousel = this.faqVideoCarousel?.nativeElement;
    const pageCount = this.carouselPages.length;
    if (!carousel || !pageCount) return;
    this.carouselPage = Math.max(0, Math.min(page, pageCount - 1));
    const targetCard = carousel.children.item(this.carouselPage * this.visibleCarouselCards) as HTMLElement | null;
    carousel.scrollTo({ left: targetCard?.offsetLeft || 0, behavior: 'smooth' });
  }

  get visibleCarouselCards(): number {
    if (window.innerWidth > 991) return 3;
    if (window.innerWidth >= 576) return 2;
    return 1;
  }

  get hasPlaceholderCarousel(): boolean {
    return !this.FaqVideoCarousel.length && this.FaqVideoCarouselSlots.length > 0;
  }

  @HostListener('window:resize')
  onCarouselResize(): void {
    this.updateCarouselRenderItems(true);
  }

  private updateCarouselRenderItems(preservePage = false): void {
    const itemCount = this.FaqVideoCarousel.length;
    if (!itemCount) {
      this.FaqVideoCarouselSlots = Array.from({ length: 6 }, () => null);
      this.FaqVideoCarouselRenderItems = this.FaqVideoCarouselSlots;
      this.carouselPage = 0;
      return;
    }

    this.FaqVideoCarouselSlots = [...this.FaqVideoCarousel];
    const pageCount = Math.ceil(itemCount / this.visibleCarouselCards);
    this.carouselPage = preservePage
      ? Math.min(this.carouselPage, pageCount - 1)
      : 0;
    this.FaqVideoCarouselRenderItems = [...this.FaqVideoCarousel];
    setTimeout(() => this.silentlyPositionCarousel());
  }

  onCarouselScroll(): void {
    if (this.carouselScrollSettleTimer) clearTimeout(this.carouselScrollSettleTimer);
    this.carouselScrollSettleTimer = setTimeout(() => this.updateCarouselPageFromScroll(), 120);
  }

  private silentlyPositionCarousel(): void {
    const carousel = this.faqVideoCarousel?.nativeElement;
    if (!carousel) return;
    const targetCard = carousel.children.item(this.carouselPage * this.visibleCarouselCards) as HTMLElement | null;
    if (!targetCard) return;
    carousel.style.scrollBehavior = 'auto';
    carousel.scrollTo({ left: targetCard.offsetLeft, behavior: 'auto' });
    carousel.style.scrollBehavior = '';
  }

  private updateCarouselPageFromScroll(): void {
    const carousel = this.faqVideoCarousel?.nativeElement;
    if (!carousel) return;
    const pageOffsets = this.carouselPages.map((page) => {
      const card = carousel.children.item(page * this.visibleCarouselCards) as HTMLElement | null;
      return card?.offsetLeft || 0;
    });
    this.carouselPage = pageOffsets.reduce(
      (nearestPage, offset, page) => Math.abs(offset - carousel.scrollLeft) < Math.abs(pageOffsets[nearestPage] - carousel.scrollLeft) ? page : nearestPage,
      0
    );
  }

  constructor(public router: Router, private service: GlobalService) {
    if(isValidStored('grw_login')){
      this.loginTrue = true;
    }
    this.loginDetail = getLocalJSON('grw_login');
    this.getFaqs();
   }

  getFaqs(){
    this.loading = true;
    this.errorMessage = '';
    const url = "/faq"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        response.data.faq.filter((el:any)=>{
          if(self.loginTrue){
            if(el.forLoggedIn){
              self.FaqList.push(el)
            }
          } else {
            if(!el.forLoggedIn){
              self.FaqList.push(el)
            }
          }
        })
        this.FaqOtherDetail = response.data.content;
        this.Faqdata=response.data;
        const apiCarouselItems = (response.data.video_carousel || [])
          .filter((item: any) => item?.video)
          .slice(0, 6);
        this.FaqVideoCarousel = apiCarouselItems;
        this.updateCarouselRenderItems();
        this.loading = false;
        // The carousel element is created after loading becomes false.
        setTimeout(() => this.updateCarouselRenderItems());
        if(this.loginTrue){
        $('#texts').removeClass('container');
        $('#texts').addClass('page-wrapper');
      } else {
        $('#texts').addClass('container');
        $('#texts').removeClass('page-wrapper');
      }
      } else {
        this.loading = false;
        this.errorMessage = 'FAQ content is currently unavailable.';
      }
    }), (error) => {
      this.loading = false;
      this.errorMessage = 'Unable to load FAQ content. Please try again later.';
    });
  }

  ngOnDestroy(): void {
    if (this.carouselScrollSettleTimer) clearTimeout(this.carouselScrollSettleTimer);
  }

  downloadFile(url: any) {
    fetch(url)
      .then((res) => res.blob())
      .then((file) => {
        let tempUrl = URL.createObjectURL(file);
        const aTag = document.createElement("a");
        aTag.href = tempUrl;
        aTag.download = url.replace(/^.*[\\\/]/, "");
        document.body.appendChild(aTag);
        aTag.click();
        URL.revokeObjectURL(tempUrl);
        aTag.remove();
      })
      .catch(() => {
        this.service.dangerAlert("Please contact administrator");
      });
  }

   plays(){
    var ss:any= this.getFaqVideo();
    if(!ss || this.isBunnyVideo(this.Faqdata?.video)) return;
    if(ss.paused){
     ss.play();
     this.showButton=false;
    } else {
     ss.pause();
     this.showButton=true;
    }  
   }

  private getFaqVideo(): HTMLVideoElement | null {
    return document.getElementById('myAudio1') as HTMLVideoElement | null;
  }

  onVideoPlay(): void { this.showButton = false; }
  onVideoPause(): void { this.showButton = true; }
  onVideoEnded(): void { this.showButton = true; this.videoProgress = 100; }

  updateVideoProgress(): void {
    const video = this.getFaqVideo();
    if (!video) return;
    this.currentTime = video.currentTime || 0;
    this.videoDuration = Number.isFinite(video.duration) ? video.duration : 0;
    this.videoProgress = this.videoDuration ? (this.currentTime / this.videoDuration) * 100 : 0;
    this.volume = video.volume;
    this.isMuted = video.muted;
    this.playbackRate = video.playbackRate;
  }

  setVideoProgress(event: Event): void {
    const video = this.getFaqVideo();
    if (!video || !Number.isFinite(video.duration)) return;
    video.currentTime = (Number((event.target as HTMLInputElement).value) / 100) * video.duration;
    this.updateVideoProgress();
  }

  setVolume(event: Event): void {
    const video = this.getFaqVideo();
    const value = Number((event.target as HTMLInputElement).value);
    if (!video) return;
    video.volume = value;
    video.muted = value === 0;
    this.volume = value;
    this.isMuted = video.muted;
  }

  toggleMute(): void {
    const video = this.getFaqVideo();
    if (!video) return;
    video.muted = !video.muted;
    this.isMuted = video.muted;
  }

  setPlaybackRate(event: Event): void {
    const video = this.getFaqVideo();
    const rate = Number((event.target as HTMLSelectElement).value);
    if (!video || !Number.isFinite(rate)) return;
    video.playbackRate = rate;
    this.playbackRate = rate;
  }

  setSleepTimer(event: Event): void {
    const minutes = Number((event.target as HTMLSelectElement).value);
    if (this.sleepTimerId) clearTimeout(this.sleepTimerId);
    this.sleepTimerMinutes = minutes;
    if (!minutes) return;

    this.sleepTimerId = setTimeout(() => {
      const video = this.getFaqVideo();
      video?.pause();
      this.sleepTimerMinutes = 0;
    }, minutes * 60 * 1000);
  }

  toggleFullscreen(): void {
    const player = document.querySelector('.faq-video-card .card-video-box') as HTMLElement | null;
    if (!player) return;
    if (document.fullscreenElement) document.exitFullscreen();
    else player.requestFullscreen();
  }

  formatVideoTime(value: number): string {
    if (!Number.isFinite(value) || value < 0) return '0:00';
    return `${Math.floor(value / 60)}:${Math.floor(value % 60).toString().padStart(2, '0')}`;
  }


   scrollTop() {
    window.scroll(0,2000);
    // $('html, body').animate({scrollTop:0}, '0');
  }
}
